export default "__VITE_ASSET__BfbqNOI$__"